import { Ordering, QueryVisitOrdersArgs } from 'gql-types';

import { BaseFilterLookup, Filter } from './lists/filtering';
import { OrderPartialMap } from './lists/ordering';

/**********************
 * Visit Order Types
 *********************/
export namespace VisitOrder {
    export type Filters = VisitOrderFilters;
    export type Ordering = VisitOrderOrdering;
    export type ListVariables = QueryVisitOrdersArgs;
}
type VisitOrderFilters = Filter<{
    state: BaseFilterLookup<VisitOrderState>;
    outcome: BaseFilterLookup<VisitOrderOutcome>;
    searchTerm: string;
}>;

type VisitOrderOrdering = OrderPartialMap<{
    updatedAt: Ordering;
}>;

/**********************
 * Visit Order Enums
 *********************/
export enum VisitOrderState {
    DRAFT = 'DRAFT',
    NEEDS_ATTENTION = 'NEEDS_ATTENTION',
    ACTIVE = 'ACTIVE',
    NEEDS_OUTCOME = 'NEEDS_OUTCOME',
    ENDED = 'ENDED',
    ALL = 'ALL',
}

export enum VisitOrderOutcome {
    NONE = 'NONE',
    COMPLETED = 'COMPLETED',
    DISCONTINUED = 'DISCONTINUED',
    EXTENDED = 'EXTENDED',
    CANCELED = 'CANCELED',
}

export const renderVisitOrderState = (state: VisitOrderState): string => {
    switch (state) {
        case VisitOrderState.DRAFT:
            return 'Draft';
        case VisitOrderState.NEEDS_ATTENTION:
            return 'Needs Attention';
        case VisitOrderState.ACTIVE:
            return 'Active';
        case VisitOrderState.NEEDS_OUTCOME:
            return 'Needs Outcome';
        case VisitOrderState.ENDED:
            return 'Ended';
        default:
            return 'Unknown';
    }
};
